import { getWorkspaceIdFromCurrentUrl, useCurrentWorkspace } from '@/context/current-workspace';
import { useMasqLink } from '@/utils/navigation';
import { Link } from '@customerio/pluma-components/react';
import { AuditLogsPageContainer } from '@/features/audit-logs/components/audit-logs-page-container';

export const WorkspaceAuditLogs = () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  const currentWorkspace = useCurrentWorkspace();
  const workspaceName = currentWorkspace?.name ?? '';
  const pageTitle = workspaceName !== '' ? `${workspaceName} Audit Logs` : 'Audit Logs';
  const masqLink = useMasqLink();

  return (
    <AuditLogsPageContainer
      context="workspace"
      contextId={workspaceId}
      workspaceId={workspaceId}
      breadcrumbs={[
        { text: 'Workspace settings', href: `/workspaces/${workspaceId}/settings` },
        { text: 'Audit logs' },
      ]}
      pageTitle={pageTitle}
      pageDescription={
        <>
          View audit logs for this workspace to track changes and activities. Looking for account-level changes like
          team members or roles? <Link href={masqLink('/settings/audit-logs')}>View Account Audit Logs</Link>
        </>
      }
      backUrlBase={`/workspaces/${workspaceId}/settings/audit-logs`}
      feedbackFeature="Workspace Audit Logs"
    />
  );
};
